import * as React from 'react';
import { StoryFn, Meta } from '@storybook/react';
import {
    CloudUploadOutlined,
    VerifiedOutlined,
    InfoCircleOutlined,
} from '@ant-design/icons';
import { Input, InputProps } from './Input';

export default {
    title: 'Ant/Input',
    component: Input,
    argTypes: {
        size: {
            options: ['small', 'middle', 'large'],
            control: 'radio',
        },
        value: {
            control: 'text',
        },
        defaultValue: {
            control: 'text',
        },
        addonBefore: {
            control: 'object',
        },
        addonAfter: {
            control: 'object',
        },
        suffix: {
            control: 'object',
        },
        prefix: {
            control: 'object',
        },
    },
    args: {
        maxLength: 100000,
        disabled: false,
        placeholder: 'Nothing here...',
    },
} as Meta;

const Template: StoryFn<InputProps> = args => <Input {...args} />;

export const Default = Template.bind({});

export const MaxLength = Template.bind({});
MaxLength.args = {
    placeholder: 'No more than 10 chars',
    maxLength: 10,
};

export const Suffix = Template.bind({});
Suffix.args = {
    suffix: <VerifiedOutlined />,
    placeholder: 'Place ur stuff here',
};

export const Prefix = Template.bind({});
Prefix.args = {
    prefix: <VerifiedOutlined />,
    placeholder: 'Place more stuff here',
};

export const SuffixPrefixIcon = Template.bind({});
SuffixPrefixIcon.args = {
    prefix: <VerifiedOutlined />,
    suffix: <InfoCircleOutlined />,
    placeholder: 'Press enter to search on the best browser',
};

export const SuffixPrefixText = Template.bind({});
SuffixPrefixText.args = {
    prefix: 'Sergius',
    suffix: 'Galba',
    defaultValue: 'Suplicius',
};

const AddonBefore = Template.bind({});
AddonBefore.args = {
    defaultValue: '127.0.0.1',
    addonBefore: 'http://',
};

export const AddonAfter = Template.bind({});
AddonAfter.args = {
    defaultValue: 'goggle',
    addonAfter: '.com',
};

export const AddonBeforeAfter = Template.bind({});
AddonBeforeAfter.args = {
    defaultValue: 'alude',
    addonAfter: <span className="semibold-alude">.com.br</span>,
    addonBefore: <span className="semibold-alude">www</span>,
};

export const File = Template.bind({});
File.args = {
    prefix: <CloudUploadOutlined />,
    placeholder: 'Upload your stuff here!',
    type: 'file',
    suffix: 'Up to 100MB',
};

export const AllowClear = Template.bind({});
AllowClear.args = {
    allowClear: true,
};
